import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { ListStateAction, ListStateSuggestion } from 'src/app/core/models/list-state.model';
import { ListState, ListStateAppearance } from 'src/app/core/types/list-state.type';

@Component({
  selector: 'app-list-state',
  templateUrl: './list-state.component.html',
  styleUrl: './list-state.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListStateComponent {
  @Input({ required: true }) state: ListState = 'ready';
  @Input() appearance: ListStateAppearance = 'card';
  @Input() bordered = false;
  @Input() icon = 'mdi-package-variant-closed-remove';
  @Input() title = 'Nenhum item encontrado';
  @Input() description = '';
  @Input() loadingText = 'Buscando itens…';
  @Input() errorText = 'Não foi possível carregar os dados.';
  @Input() action?: ListStateAction | null;
  @Input() clearAction?: ListStateAction | null;
  @Input() suggestion?: ListStateSuggestion | null;

  @HostBinding('class.list-state-bordered') get hasBorder(): boolean { return this.bordered; }
  @HostBinding('class.list-state-ready') get hidden(): boolean { return this.state === 'ready'; }
  @HostBinding('class.list-state-embedded') get embedded(): boolean { return this.appearance === 'embedded'; }

  get displayTitle(): string {
    if (this.state === 'loading') return this.loadingText;
    if (this.state === 'error') return this.errorText;
    return this.state === 'suggestion' ? this.suggestion?.title || this.title : this.title;
  }

  get displayIcon(): string { return this.state === 'error' ? 'mdi-alert-circle-outline' : this.icon; }

  canShowAction(action?: ListStateAction | null): boolean {
    return typeof action?.callBack === 'function' || !!action?.routerLink;
  }
}
